import { BaseColor, Stack } from '@prophecy/ui';
import { GemInnerStoredProceduresIcon, GemSpatialIcon } from '@prophecy/ui-v3/Icons';
import { EntityIcon as EntityIconBase } from '@prophecy/ui-v3/Misc/EntityIcon';
import {
  VariantType as EntityIconVariantType,
  SizeType as EntityIconSizeType
} from '@prophecy/ui-v3/Misc/EntityIcon/types';
import { getColorCode } from '@prophecy/ui-v3/theme/utils';
import styled, { css } from 'styled-components';

import { Entity, getAppEntityName } from '../types/Entity';
import { EntityIconKey, EntityIconMap, EntityToneMap } from './constants';

type Tone = `${BaseColor}`;
export function getTokens(tone: Tone) {
  return {
    color: getColorCode(tone, 600),
    backgroundType: {
      default: {
        color: getColorCode(tone, 600),
        border: getColorCode(tone, 200),
        background: getColorCode(tone, 50)
      },
      solid: {
        color: getColorCode(tone, 100),
        border: getColorCode(tone, 200),
        background: getColorCode(tone, 600)
      }
    }
  };
}

export const IconWrapper = styled(Stack)<{ $radius: string; $background: string; $border?: string }>`
  background: ${(props) => props.$background};
  border-radius: ${(props) => props.$radius};
  ${(props) =>
    props.$border &&
    css`
      border: 1px solid ${props.$border};
    `};
  flex-shrink: 0;
`;

export interface EntityIconProps {
  entity: EntityIconKey;
  tooltip?: React.ReactNode;
  size?: EntityIconSizeType;
  className?: string;
  hideTooltip?: boolean;
  variant?: EntityIconVariantType;
  disabled?: boolean;
}
export function EntityIcon({
  entity,
  tooltip,
  size = 'm',
  className,
  variant,
  hideTooltip,
  disabled
}: EntityIconProps) {
  const iconObj = EntityIconMap[entity as EntityIconKey];

  if (!iconObj) {
    console.error(`No icon found for entity: ${entity}`);
    return null;
  }

  let { icon: Icon, type: iconType } = iconObj;
  const tokens = getTokens(EntityToneMap[entity as EntityIconKey]);
  const title = tooltip ?? getAppEntityName(entity as Entity);

  // One-off cases for some Gem type icons
  if (entity === Entity.Spatial) {
    Icon = styled(GemSpatialIcon)`
      fill: none;
    `;
  }
  if (entity === Entity.StoredProcedure) {
    Icon = styled(GemInnerStoredProceduresIcon)`
      &&& path {
        stroke-width: 2.5;
      }
    `;
  }
  // --------------O--------------- //

  return (
    <EntityIconBase
      variant={variant}
      size={size}
      icon={
        // @ts-ignore
        <Icon type={iconType} color={tokens.color} />
      }
      color={disabled ? BaseColor.gray : EntityToneMap[entity as EntityIconKey]}
      tooltip={title}
      hideTooltip={hideTooltip}
      className={className}
    />
  );
}
